import React from "react";
import { ServiceAction } from '../../interfaces/services'

interface Props {
  selectedAction: ServiceAction
  closeModal: () => void
  handleConfirmAction: () => void
  isProcessing: boolean
  selectedArtisan: string
}

const RenderModalFooter: React.FC<Props> = ({
  selectedAction,
  closeModal,
  handleConfirmAction,
  isProcessing,
  selectedArtisan
}) => {

  if (selectedAction === 'viewDetails') {
    return (
      <div className="flex justify-end gap-3">
        <button
          onClick={closeModal}
          className="px-6 py-2 border border-gray-300 rounded-lg hover:bg-gray-50"
        >
          Close
        </button>
        <button
          onClick={closeModal}
          className="px-6 py-2 bg-black text-white rounded-lg hover:bg-gray-800"
        >
          Send a reminder
        </button>
      </div>
    )
  }

  if (selectedAction === 'assignArtisan' || selectedAction === 'reassign') {
    const label = selectedAction === 'assignArtisan' ? 'Assign' : 'Reassign'
    const loadingLabel = selectedAction === 'assignArtisan' ? 'Assigning...' : 'Reassigning...'

    return (
      <div className="flex justify-end gap-3">
        <button
          onClick={closeModal}
          disabled={isProcessing}
          className="px-6 py-2 border border-gray-300 rounded-lg disabled:opacity-50"
        >
          Cancel
        </button>
        <button
          onClick={handleConfirmAction}
          disabled={!selectedArtisan || isProcessing}
          className="px-6 py-2 bg-black text-white rounded-lg disabled:cursor-not-allowed disabled:opacity-100 disabled:transform-none disabled:shadow-none disabled:bg-gray-400 enabled:hover:bg-gray-800"
        >
          {isProcessing ? loadingLabel : label}
        </button>
      </div>
    )
  }

  if (selectedAction === 'cancelRequest') {
    return (
      <div className="flex justify-end gap-3">
        <button
          onClick={closeModal}
          disabled={isProcessing}
          className="px-6 py-2 border border-gray-300 rounded-lg disabled:opacity-50"
        >
          No, keep it
        </button>
        <button
          onClick={handleConfirmAction}
          disabled={isProcessing}
          className="px-6 py-2 bg-red-600 text-white rounded-lg disabled:cursor-not-allowed disabled:opacity-100 disabled:transform-none disabled:shadow-none disabled:bg-red-300 enabled:hover:bg-red-700"
        >
          {isProcessing ? 'Cancelling...' : 'Yes, cancel request'}
        </button>
      </div>
    )
  }

  return null
}

export default RenderModalFooter